import React from 'react'
import 'antd/dist/antd.css'
import actionWays from '../../../redux/actions'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Descriptions, Spin, Tabs, Radio, message } from 'antd'
import 'swiper/swiper.scss'
import './index.scss'
import gouwu from '../../../assets/surroundingFacility/gouwu.png'
import gouwuActive from '../../../assets/surroundingFacility/gouwuActive.png'
import jiaotong from '../../../assets/surroundingFacility/jiaotong.png'
import jiaotongActive from '../../../assets/surroundingFacility/jiaotongActive.png'
import jiaoyu from '../../../assets/surroundingFacility/jiaoyu.png'
import jiaoyuActive from '../../../assets/surroundingFacility/jiaoyuActive.png'
import yiliao from '../../../assets/surroundingFacility/yiliao.png'
import yiliaoActive from '../../../assets/surroundingFacility/yiliaoActive.png'
import yinhang from '../../../assets/surroundingFacility/yinhang.png'
import yinhangActive from '../../../assets/surroundingFacility/yinhangActive.png'
import yule from '../../../assets/surroundingFacility/yule.png'
import yuleActive from '../../../assets/surroundingFacility/yuleActive.png'
import name from '../../../assets/surroundingFacility/name.png'
const { TabPane } = Tabs
class SurroundingFacility extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectTabArr: ['地铁站', '公交站'],
      selectActiveIndex: 0,
      mapListContainerLoading: true,
      baiduIndex: '地铁站',
      baiduLoading: false,
      distance: 500,
      distanceArr: [
        {
          title: '0.5km',
          key: 500,
        },
        {
          title: '1km',
          key: 1000,
        },
        {
          title: '1.5km',
          key: 1500,
        },
        {
          title: '2km',
          key: 2000,
        },
        {
          title: '2.5km',
          key: 2500,
        },
        {
          title: '5km',
          key: 5000,
        },
      ],
      tableArr: [
        {
          title: '交通',
          key: '地铁站,公交站',
          icon: jiaotong,
          iconActive: jiaotongActive,
        },
        {
          title: '教育',
          key: '幼儿园,小学,中学,大学',
          icon: jiaoyu,
          iconActive: jiaoyuActive,
        },
        {
          title: '医疗',
          key: '医院,药店',
          icon: yiliao,
          iconActive: yiliaoActive,
        },
        {
          title: '购物',
          key: '超市,商场,便利店',
          icon: gouwu,
          iconActive: gouwuActive,
        },
        {
          title: '银行',
          key: '银行',
          icon: yinhang,
          iconActive: yinhangActive,
        },
        {
          title: '娱乐',
          key: '景点,广场',
          icon: yule,
          iconActive: yuleActive,
        },
      ],
      ambitusArr: [],
      activeId: '',
      markerLists: [],
      isChange: false,
    }
  }
  componentDidMount() {
    let _self = this
    if (this.props.dataLocation && this.props.dataLocation != undefined) {
      _self.setMap(this.props.dataLocation, this.props.dataCommunityName)
      _self.map = new window.AMap.Map('mapContainer', {
        resizeEnable: true,
      })
      _self.setState({
        baiduLoading: true,
      })
    }
  }

  aMapSearch = () => {
    const { distance, selectTabArr, selectActiveIndex, tableArr, markerLists } =
      this.state
    this.setState({
      mapListContainerLoading: false,
      // baiduIndex: w
    })
    let _self = this
    let map
    const point = window.point
    const communityName = window.communityName
    // 渲染中心地点
    var markerCenter = new AMap.Marker({
      map: map,
      position: point,
      content:
        `
            <div style="position: absolute;
            height: 0px;
            width: 0px;
            left: -30px;
            top: 0px;
            z-index: 500;">
            <div style="position: absolute;
            z-index: 11806282;
            background-color: rgb(75, 128, 248);
            border: 1px solid rgb(75, 128, 248);
            color: white;
            padding: 0px 5px;
            line-height: 18px;
            white-space: nowrap;
            font-size: 14px;
            user-select: none;
            left: 0px;
            top: 0px;"
            >
            <span>` +
        communityName +
        `</span>
            <img src="` +
        name +
        `" style="position: absolute;
            width: 35px ;
            height: 38px ;
            top: 15px ;
            left: 12px ;
            overflow: hidden;"/>
            </div></div>
            `, //自定义覆盖物样式，可传可不传
    })
    this.map.clearMap()
    this.map.add(markerCenter)
    // 渲染圆
    var circle = new AMap.Circle({
      center: point,
      radius: distance,
      fillColor: 'RGB(184,215,209)',
      strokeWeight: 1,
      fillOpacity: 0.5,
      strokeOpacity: 0.5,
    })
    console.log(point, distance, circle)
    circle.setMap(this.map)
    // 渲染周边
    AMap.service(['AMap.PlaceSearch'], function () {
      var myIconActive = tableArr[selectActiveIndex].iconActive
      //构造地点查询类
      var placeSearch = new AMap.PlaceSearch({
        pageSize: 100000, // 单页显示结果条数
        pageIndex: 1, // 页码
        city: '上海市', // 兴趣点城市
        citylimit: true, //是否强制限制在设置的城市内搜索
        map: map, // 展现结果的地图实例
      })
      _self.setState({
        markerLists: [],
        ambitusArr: [],
      })
      let arr = []
      let markers = []
      for (let i = 0; i < selectTabArr?.length; i++) {
        placeSearch.searchNearBy(
          selectTabArr[i],
          point,
          distance,
          function (status, result) {
            if (result?.info == 'OK') {
              let arrCon = {
                keyword: selectTabArr[i],
                contentArr: result?.poiList.pois,
              }
              let pointList = result?.poiList.pois
              for (let j = 0; j < pointList.length; j++) {
                var marker = new AMap.Marker({
                  position: new AMap.LngLat(
                    pointList[j].location.lng,
                    pointList[j].location.lat
                  ),
                  clickable: true,
                  icon: myIconActive,
                  extData: {
                    id: j + 1,
                  },
                })
                marker.on('click', function (e) {
                  _self.markerClick(pointList[j])
                })
                _self.map.add(marker)
                markers.push(marker)
              }
              arr.push(arrCon)
            }
          }
        )
      }
      console.log(markers)
      setTimeout(() => {
        console.log(arr)
        var overlayGroups = new AMap.OverlayGroup(markers)
        _self.map.add(overlayGroups)
        _self.setState({
          ambitusArr: arr,
          mapListContainerLoading: true,
          isChange: false,
        })
      }, 500)
    })
  }
  setMap = (location, communityName) => {
    let _self = this
    var myGeo = new window.AMap.Geocoder()
    // AMap.plugin('AMap.Geocoder', function () {
    //     myGeo = new AMap.Geocoder()
    // }, () => {
    // })
    // myGeo.getLocation(location, function (status, result) {
    //     if (status === 'complete' && result.geocodes.length) {
    //         var lnglat = result.geocodes[0].location
    //         window.communityName = communityName
    //         window.point = [lnglat.lng, lnglat.lat]
    // _self.map.setZoomAndCenter(14, [lnglat.lng, lnglat.lat])
    // _self.aMapSearch()
    //     } else {
    //         // errorMessage('根据地址查询位置失败');
    //     }
    // })
    AMap.service('AMap.PlaceSearch', function () {
      var placeSearch = new AMap.PlaceSearch({
        // city 指定搜索所在城市，支持传入格式有：城市名、citycode和adcode
        city: '021',
      })
      console.log(location)
      placeSearch.search(location, function (status, result) {
        var lnglat = ''
        for (let j = 0; j < result.poiList?.pois.length; j++) {
          if (result.poiList?.pois[j].name.indexOf(communityName) !== -1) {
            lnglat = lnglat ? lnglat : result.poiList?.pois[j]?.location
          }
        }
        lnglat = lnglat ? lnglat : result.poiList?.pois[0]?.location
        window.communityName = communityName
        window.point = [lnglat.lng, lnglat.lat]
        _self.map.setZoomAndCenter(14, [lnglat.lng, lnglat.lat])
        _self.aMapSearch()
      })
    })
  }
  callbackBtn = (key) => {
    console.log(this.state.isChange)
    console.log('isChangeisChangeisChange')
    if (this.state.isChange) {
      return message.error('请勿重复操作')
    } else {
      let select = JSON.parse(key)
      let selectTabArr = select?.key?.split(',')
      this.setState(
        {
          selectTabArr,
          selectActiveIndex: select.index,
          activeId: '',
          distance: 500,
          isChange: true,
        },
        () => {
          this.aMapSearch()
        }
      )
    }
  }

  totalTabPane = (item, index) => {
    return (
      <TabPane
        tab={item}
        key={item + '-' + index}
        style={{ padding: '0 1em' }}
      ></TabPane>
    )
  }
  totalDistancePane = (item, index) => {
    return (
      <Radio.Button value={item.key} key={item + '-+-' + index}>
        {item.title}
      </Radio.Button>
    )
  }
  changeDistance = (e) => {
    this.setState(
      {
        distance: Number(e.target.value),
      },
      () => {
        this.aMapSearch()
      }
    )
  }
  markerClick(e) {
    this.map.setCenter([e.location.lng, e.location.lat])
    this.map.setZoom(18)
    this.setState({
      activeId: e.id,
    })
  }
  render() {
    const {
      selectTabArr,
      mapListContainerLoading,
      baiduIndex,
      baiduLoading,
      distance,
      distanceArr,
      ambitusArr,
      activeId,
      tableArr,
      selectActiveIndex,
    } = this.state

    return (
      <div>
        {
          this.props.dataCommunityName == '中企联合大厦13层' ?
            <div id="SurroundingFacility" style={{ width: "100%" }}>
              <Descriptions className="zhoubian">
                <div className='zhoubianBox'>
                  <div className='zhoubianNew'>
                    <p style={{ fontSize: '14px', fontWeight: '600' }}>上海奉贤保障性住房有限公司</p>
                    <p style={{ fontSize: '12px' }}>中企联合大厦13层</p>
                    <div className='backgroundimageBox'>
                      <a href='https://www.amap.com/search?query=%E4%B8%AD%E4%BC%81%E8%81%94%E5%90%88%E5%A4%A7%E5%8E%A613%E5%B1%82&city=310000'>
                        前往导航
                      </a>
                      <div className='backgroundimageDiv'></div>
                    </div>
                  </div>
                  <div id="mapContainer" style={{ width: '100%' }}></div>
                </div>
              </Descriptions>
            </div> : <div id="SurroundingFacility">
              <Descriptions title="周边配套" className="zhoubian">
                <div style={{ position: 'relative' }}>
                  <div id="mapContainer" style={{ width: '100%' }}></div>
                  <div className="mapCon">
                    <Tabs type="card" onChange={this.callbackBtn}>
                      {tableArr?.map((item, index) => {
                        return (
                          <TabPane
                            tab={item.title}
                            key={JSON.stringify({ ...item, index: index })}
                          ></TabPane>
                        )
                      })}
                    </Tabs>
                    <div style={{ paddingBottom: '10px', background: '#fff' }}>
                      <Radio.Group
                        value={distance}
                        size={'middle'}
                        buttonStyle="solid"
                        onChange={(key) => {
                          this.changeDistance(key)
                        }}
                      >
                        {distanceArr.length > 0
                          ? distanceArr.map(this.totalDistancePane)
                          : null}
                      </Radio.Group>
                    </div>
                    <ul
                      id="mapContentArr"
                      style={{
                        overflow: 'auto',
                        background: '#fff',
                      }}
                    >
                      {ambitusArr?.map((it, index) => {
                        return (
                          <div
                            className="mapContentArr_li"
                            key={'mapContentArr_li-' + index}
                          >
                            <div className="mapContentArr_title"> {it.keyword}</div>
                            {it.contentArr?.map((item, indexskey) => {
                              return (
                                <div
                                  key={'mapContentArr_li-' + index + '-' + indexskey}
                                  onClick={() => {
                                    this.markerClick(item)
                                  }}
                                  className="mapContentArr_con"
                                >
                                  <div
                                    className={
                                      activeId == item.id
                                        ? 'mapContentArr_con_active'
                                        : ''
                                    }
                                  >
                                    <div>
                                      <img
                                        src={tableArr[selectActiveIndex].icon}
                                      ></img>
                                      {item.name}
                                    </div>
                                    <div>{item.distance}米</div>
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                        )
                      })}
                    </ul>
                    {mapListContainerLoading ? null : (
                      <Spin
                        style={{ position: 'absolute', top: '50%', left: '50%' }}
                      />
                    )}
                  </div>
                </div>
              </Descriptions>
            </div>
        }
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SurroundingFacility))
